import { useState } from "react";
import { useNavigate } from "react-router-dom";

import UseNotification from "Hooks/UseNotification";

import GetIcon from "Components/Global/Icons";

import Notification from "./Components/Notification";
import * as S from "./styles";

import { useTheme } from "styled-components";

/*
 * Caixa de notificações do sino — reescrita na parte 4 (D5, 05/09/2026).
 *
 * O QUE MUDOU E POR QUÊ
 * ---------------------
 * Saíram as abas "Não lida"/"Todas", o "Ver mais" e o "Marcar como lida". Nesta
 * versão a caixa é só de ALERTAS do sistema: estado computado pelo servidor,
 * não mensagem persistida. Enquanto houver pendência o alerta existe; quando
 * zera, ele some sozinho — não há o que marcar como lido.
 *
 * Hoje o único alerta é o de aprovações pendentes, que é do ADMIN — o polling
 * nem roda para o usuário comum.
 *
 * ⚠️ CORREÇÃO DE 20/09/2026. A reescrita deixou a caixa do usuário COMUM
 * permanentemente vazia: ela passou a renderizar só `alerts`, que é admin-only,
 * enquanto as notificações dele continuavam sendo buscadas
 * (`/notifications/list-active-notifications`) e gravadas — e nunca exibidas.
 * O proponente recebia "Nova Mensagem!" no banco e via "Nenhuma notificação" na
 * tela. Agora cada perfil lê a sua fonte: ADMIN os alertas computados, COMUM as
 * próprias notificações persistidas, com o `Notification` que já existia.
 *
 * ⚠️ O mecanismo antigo continua INTACTO — tabelas, CRUD do admin, toasts e
 * popups automáticos.
 */
const Notifications = ({
  openNotifications,
  setOpenNotifications,
  isAdmin,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const { alerts, regularNotifications } = UseNotification();

  // O admin lê alertas computados; o usuário comum, as próprias notificações.
  const ownNotifications = regularNotifications || [];

  const [animationIn, setAnimationIn] = useState(true);

  const close = () => {
    setOpenNotifications(false);
    setAnimationIn(false);
  };

  const open = (alert) => {
    if (!alert.link) return;

    close();
    navigate(alert.link);
  };

  return (
    <S.Modal
      animationIn={animationIn}
      openNotifications={openNotifications}
      isAdmin={isAdmin}
    >
      <S.Title isAdmin={isAdmin}>
        <h1>Notificações</h1>

        <GetIcon
          name="X"
          color={theme.colors.primary.blue}
          size="md"
          onClick={close}
        />
      </S.Title>

      <S.NotificationWrapper>
        <S.NotificationScroll>
          <S.Notifications>
            {isAdmin ? (
              <>
                {!alerts?.length && (
                  <S.NoNotifications>Nenhuma notificação</S.NoNotifications>
                )}

                {(alerts || []).map((alert) => (
                  <S.Alert
                    key={alert.id}
                    onClick={() => open(alert)}
                    $clickable={Boolean(alert.link)}
                  >
                    <h3>{alert.title}</h3>
                  </S.Alert>
                ))}
              </>
            ) : (
              <>
                {!ownNotifications.length && (
                  <S.NoNotifications>Nenhuma notificação</S.NoNotifications>
                )}

                {ownNotifications.map((notification) => (
                  <Notification
                    key={notification.id}
                    notification={notification}
                  />
                ))}
              </>
            )}
          </S.Notifications>
        </S.NotificationScroll>
      </S.NotificationWrapper>
    </S.Modal>
  );
};

export default Notifications;
